import { render, staticRenderFns } from "./BindingMobileHome.vue?vue&type=template&id=7b33ee30&"
import script from "./BindingMobileHome.vue?vue&type=script&lang=js&"
export * from "./BindingMobileHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports